module.exports = __webpack_public_path__ + "img/20210612.67d0e9f7.png";